/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateDeveloperAppRequestBody
 */
export interface UpdateDeveloperAppRequestBody {
    /**
     * Developer app name
     * @type {string}
     * @memberof UpdateDeveloperAppRequestBody
     */
    name: string;
    /**
     * App description
     * @type {string}
     * @memberof UpdateDeveloperAppRequestBody
     */
    description?: string;
    /**
     * App logo/image URL
     * @type {string}
     * @memberof UpdateDeveloperAppRequestBody
     */
    imageUrl?: string;
    /**
     * Pre-registered OAuth redirect/callback URIs
     * @type {Array<string>}
     * @memberof UpdateDeveloperAppRequestBody
     */
    redirectUris?: Array<string>;
}

/**
 * Check if a given object implements the UpdateDeveloperAppRequestBody interface.
 */
export function instanceOfUpdateDeveloperAppRequestBody(value: object): value is UpdateDeveloperAppRequestBody {
    let isInstance = true;
    isInstance = isInstance && "name" in value && value["name"] !== undefined;

    return isInstance;
}

export function UpdateDeveloperAppRequestBodyFromJSON(json: any): UpdateDeveloperAppRequestBody {
    return UpdateDeveloperAppRequestBodyFromJSONTyped(json, false);
}

export function UpdateDeveloperAppRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDeveloperAppRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'imageUrl': !exists(json, 'image_url') ? undefined : json['image_url'],
        'redirectUris': !exists(json, 'redirect_uris') ? undefined : json['redirect_uris'],
    };
}

export function UpdateDeveloperAppRequestBodyToJSON(value?: UpdateDeveloperAppRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'image_url': value.imageUrl,
        'redirect_uris': value.redirectUris,
    };
}

